import Tag from "components/BaseWidgets/tag";
import "./style.scss";
import { PurpleCircleTick, StandardPlan } from "assets/icons";
import Divider from "components/BaseWidgets/divider";
import Button from "components/BaseWidgets/button";
import { priceFormatPrice } from "utils/formatHelper";

function PlanCard({ data, onOk, isPending, isPopular }) {
  const { title, tagText, planValidity, features, oldPrice, offerPrice,contact_view_limit } = data;

  return (
    <div className={`plan-card ${isPopular && "popular"}`}>
      <div className="flex flex-col gap-6 flex-1">
        <div className="flex flex-col gap-4 items-center">
          <span className="plan-icon">
            <StandardPlan />
          </span>
          <Tag readOnly className="plan-yellow-tag mt-1-5" variant="yellow">
            {tagText}
          </Tag>
          <div className="flex flex-col gap-2 items-center">
            <span className="font-title-lg fw-700 leading-3">{title}</span>
            <div className="flex flex-col gap-1 items-center">
              <span className="text-gray font-title-xs fw-700 leading-1">
                <span className="ml-3 text-gray">
                  {priceFormatPrice(offerPrice)}
                </span>
                <span className="ml-2 font-body-normal fw-400 leading-1 text-gray line-through">
                  {priceFormatPrice(oldPrice)}
                </span>
              </span>
              <span className="text-gray font-body-normal leading-1 flex-wrap">
                Plan validity for{" "}
                <span className="ml-2 text-gray">{planValidity} days</span>
              </span>
              <span className="text-gray font-body-normal leading-1 flex-wrap">
            Contact views
            <span className="ml-2 text-gray">{contact_view_limit}</span>
          </span>
            </div>
          </div>
        </div>
        {features && features.length > 0 && (
          <>
            <Divider />
            <ul className="flex flex-col gap-5">
              {features.map((item, i) => (
                <li key={i} className="flex items-center gap-3">
                  <span className="tick-icon">
                    <PurpleCircleTick />
                  </span>
                  <span className="font-body-lg fw-500 leading-4">{item}</span>
                </li>
              ))}
            </ul>
          </>
        )}
      </div>
      <Button
        isLoading={isPending}
        onClick={onOk}
        className="mt-3 join-btn"
        height={44}
        wFull
      >
        Join now
      </Button>
    </div>
  );
}

export default PlanCard;
